import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../services/global/global.service";

@Component({
  selector: "app-login-error-page",
  templateUrl: "./login-error-page.component.html",
  styleUrls: ["./login-error-page.component.scss"],
})
export class LoginErrorPageComponent implements OnInit {
  public adalErrorDescription: string = null;

  constructor(public globals: GlobalService, private router: Router) {}

  ngOnInit(): void {
    this.getAdalError();
  }

  public getAdalError() {
    this.adalErrorDescription = localStorage.getItem("adal.error.description");
  }

  public goToLoginPage() {
    // Remove login Error from Cache
    localStorage.removeItem("adal.error");
    this.router.navigate(["/login"]);
  }
}
